/* ==========================================================================
   Headband Offer — copy-to-clipboard + dismissible bar
   Uses event delegation on document so chips rendered later by the AJAX cart
   (mini-cart re-render) keep working without re-binding.
   Added Aug 2026.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hboInit) return;
  window.__hboInit = true;

  var COPIED_MS = 2000;

  /**
   * Copy text to the clipboard.
   * navigator.clipboard needs a secure context; fall back to a throwaway
   * textarea + execCommand so this still works on http previews and in
   * older mobile browsers.
   */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);

    var ok = false;
    try {
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  function announce(chip, message) {
    var live = chip.querySelector('[data-hbo-live]');
    if (live) live.textContent = message;
  }

  function flashCopied(chip) {
    var label = chip.getAttribute('data-hbo-copied-label') || 'Copied';
    var idle = chip.getAttribute('data-hbo-idle-label') || 'Copy code';

    chip.classList.add('is-copied');
    chip.setAttribute('aria-label', label);
    announce(chip, label);

    if (chip.__hboTimer) clearTimeout(chip.__hboTimer);
    chip.__hboTimer = setTimeout(function () {
      chip.classList.remove('is-copied');
      chip.setAttribute('aria-label', idle);
      announce(chip, '');
    }, COPIED_MS);
  }

  /* ---- Copy ------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var chip = event.target.closest ? event.target.closest('[data-hbo-copy]') : null;
    if (!chip) return;

    event.preventDefault();

    var code = chip.getAttribute('data-hbo-copy');
    if (!code) return;

    copyText(code).then(function (ok) {
      if (ok) {
        flashCopied(chip);
      } else {
        announce(chip, 'Press Ctrl+C or Cmd+C to copy');
        selectNode(chip.querySelector('.hbo-code__value') || chip);
      }
    });
  });

  function selectNode(node) {
    if (!node || !window.getSelection || !document.createRange) return;
    var range = document.createRange();
    range.selectNodeContents(node);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  /* ---- Dismiss ---------------------------------------------------------- */

  function storageKey(bar) {
    return 'hbo-dismissed:' + (bar.getAttribute('data-hbo-version') || 'v1');
  }

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function safeSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-hbo-dismiss]') : null;
    if (!btn) return;

    var bar = btn.closest('[data-hbo-bar]');
    if (!bar) return;

    event.preventDefault();
    bar.classList.add('is-dismissing');
    safeSet(storageKey(bar), '1');

    setTimeout(function () { bar.hidden = true; }, 200);
  });

  /**
   * Restore dismissed state. Skipped in the theme editor so the merchant can
   * always see the bar while editing.
   */
  function applyDismissed() {
    if (window.Shopify && window.Shopify.designMode) return;

    var bars = document.querySelectorAll('[data-hbo-bar][data-hbo-dismissible="true"]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (safeGet(storageKey(bar)) === '1') bar.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDismissed);
  } else {
    applyDismissed();
  }

  document.addEventListener('shopify:section:load', applyDismissed);
})();
